(() => {
  const Nova = (window.Nova = window.Nova || {});
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const root = (Nova.routes && Nova.routes.root ? Nova.routes.root : '/').replace(/\/$/, '');

  const store = {
    get(key, fallback) {
      try {
        const v = localStorage.getItem(key);
        return v ? JSON.parse(v) : fallback;
      } catch (e) {
        return fallback;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    },
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  Nova.toast = (msg) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };

  /* ---------- Metaal ---------- */
  Nova.getMetal = () => document.documentElement.dataset.metal || Nova.settings.defaultMetal || 'goud';
  Nova.setMetal = (key) => {
    if (key !== 'goud' && key !== 'zilver') return;
    if (Nova.getMetal() === key) return;
    document.documentElement.dataset.metal = key;
    try {
      localStorage.setItem('nova-metal', key);
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('nova:metal', { detail: { metal: key } }));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-set-metal]');
    if (!btn) return;
    if (btn.tagName === 'BUTTON') e.preventDefault();
    Nova.setMetal(btn.dataset.setMetal);
  });

  /* ---------- Verlanglijst ---------- */
  Nova.wishlist = {
    all: () => store.get('nova-wish', []),
    has: (h) => Nova.wishlist.all().includes(h),
    toggle(h) {
      const list = Nova.wishlist.all();
      const next = list.includes(h) ? list.filter((x) => x !== h) : [...list, h];
      store.set('nova-wish', next);
      Nova.wishlist.sync();
      document.dispatchEvent(new CustomEvent('nova:wish', { detail: { list: next } }));
      return next.includes(h);
    },
    add(h) {
      if (!Nova.wishlist.has(h)) Nova.wishlist.toggle(h);
    },
    sync() {
      const list = Nova.wishlist.all();
      $$('[data-wish]').forEach((b) => {
        const on = list.includes(b.dataset.wish);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-wish-count]').forEach((c) => (c.textContent = list.length ? list.length : ''));
    },
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    Nova.wishlist.toggle(btn.dataset.wish);
  });

  /* ---------- Onlangs bekeken ---------- */
  Nova.trackView = (handle) => {
    const list = store.get('nova-viewed', []).filter((h) => h !== handle);
    list.unshift(handle);
    store.set('nova-viewed', list.slice(0, 12));
  };
  Nova.viewed = () => store.get('nova-viewed', []);

  /* Productkaarten ophalen via de Section Rendering API */
  Nova.fetchCards = async (handles, limit) => {
    const picked = handles.slice(0, limit || handles.length);
    const results = await Promise.all(
      picked.map((h) =>
        fetch(`${root}/products/${encodeURIComponent(h)}?section_id=card-product`)
          .then((r) => (r.ok ? r.text() : ''))
          .catch(() => '')
      )
    );
    return results
      .map((html) => {
        if (!html) return null;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-card]');
      })
      .filter(Boolean);
  };

  const renderLists = async () => {
    for (const box of $$('[data-product-list]')) {
      const type = box.dataset.productList;
      const exclude = box.dataset.exclude || '';
      const limit = parseInt(box.dataset.limit || '4', 10);
      let handles = type === 'wish' ? Nova.wishlist.all() : Nova.viewed();
      handles = handles.filter((h) => h !== exclude);
      const wrap = box.closest('[data-list-wrap]') || box;
      const empty = wrap.querySelector('[data-list-empty]');
      const countEl = wrap.querySelector('[data-list-count]');
      if (countEl) countEl.textContent = handles.length;
      if (!handles.length) {
        if (empty) empty.hidden = false;
        if (type === 'viewed') wrap.hidden = true;
        box.innerHTML = '';
        continue;
      }
      const cards = await Nova.fetchCards(handles, type === 'wish' ? handles.length : limit);
      box.innerHTML = '';
      cards.forEach((c) => box.appendChild(c));
      wrap.hidden = cards.length === 0;
      if (empty) empty.hidden = cards.length > 0;
      Nova.wishlist.sync();
    }
  };
  document.addEventListener('nova:wish', () => {
    if ($('[data-product-list="wish"]')) renderLists();
  });

  /* ---------- Levering ---------- */
  Nova.deliveryDate = (days) => {
    const months = (Nova.strings.months || '').split(',');
    const names = (Nova.strings.days || '').split(',');
    const d = new Date();
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) left--;
    }
    return `${names[d.getDay()] || ''} ${d.getDate()} ${months[d.getMonth()] || ''}`.trim();
  };
  const fillDates = (scope = document) => {
    $$('[data-delivery-date]', scope).forEach((el) => {
      el.textContent = Nova.deliveryDate(parseInt(el.dataset.deliveryDate || Nova.settings.deliveryDays, 10));
    });
    $$('[data-month]', scope).forEach((el) => {
      const months = (Nova.strings.months || '').split(',');
      const now = new Date();
      const offset = parseInt(el.dataset.month || '0', 10);
      el.textContent = months[(now.getMonth() + offset) % 12] || '';
    });
  };

  /* ---------- Lades ---------- */
  Nova.openDrawer = (name) => {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return;
    $$('[data-drawer].is-open').forEach((x) => x !== d && Nova.closeDrawer(x));
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    const focusEl = d.querySelector('[data-drawer-focus]') || d.querySelector('button, a');
    if (focusEl) setTimeout(() => focusEl.focus(), 50);
  };
  Nova.closeDrawer = (d) => {
    const el = typeof d === 'string' ? $(`[data-drawer="${d}"]`) : d;
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('[data-drawer].is-open')) document.documentElement.classList.remove('is-locked');
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-drawer]');
    if (open) {
      const name = open.dataset.openDrawer;
      if (name === 'cart' && Nova.settings.cartType !== 'drawer') return;
      if (!$(`[data-drawer="${name}"]`)) return;
      e.preventDefault();
      Nova.openDrawer(name);
      return;
    }
    const close = e.target.closest('[data-close-drawer]');
    if (close) {
      e.preventDefault();
      Nova.closeDrawer(close.closest('[data-drawer]'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-drawer].is-open').forEach((d) => Nova.closeDrawer(d));
    closePanels();
  });

  /* ---------- Winkelmand ---------- */
  const setCount = (count) => {
    $$('[data-cart-count]').forEach((el) => (el.textContent = count > 0 ? count : ''));
  };

  Nova.refreshCart = async () => {
    const [cart, sections] = await Promise.all([
      fetch(`${root}/cart.js`).then((r) => r.json()),
      Nova.settings.cartType === 'drawer'
        ? fetch(`${window.location.pathname}?sections=cart-drawer`).then((r) => r.json()).catch(() => null)
        : Promise.resolve(null),
    ]);
    setCount(cart.item_count);
    if (sections && sections['cart-drawer']) swapDrawer(sections['cart-drawer']);
    document.dispatchEvent(new CustomEvent('nova:cart', { detail: { cart } }));
    return cart;
  };

  const swapDrawer = (html) => {
    const current = $('[data-cart-drawer-inner]');
    if (!current) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-drawer-inner]');
    if (next) current.replaceWith(next);
    Nova.wishlist.sync();
    fillDates(next || document);
  };

  Nova.addToCart = async (items, { open = true } = {}) => {
    const res = await fetch(`${Nova.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok) {
      Nova.toast(data.description || data.message || Nova.strings.error);
      throw new Error(data.description || 'add failed');
    }
    await Nova.refreshCart();
    if (open && Nova.settings.cartType === 'drawer' && $('[data-drawer="cart"]')) {
      Nova.openDrawer('cart');
    } else {
      Nova.toast(Nova.strings.added);
    }
    return data;
  };

  Nova.changeLine = async (key, quantity) => {
    const drawer = $('[data-drawer="cart"]');
    if (drawer) drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${Nova.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        Nova.toast(data.description || Nova.strings.error);
      }
      if ($('[data-cart-page]')) {
        window.location.reload();
        return;
      }
      await Nova.refreshCart();
    } finally {
      if (drawer) drawer.classList.remove('is-loading');
    }
  };

  document.addEventListener('click', async (e) => {
    const change = e.target.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      Nova.changeLine(change.dataset.key, parseInt(change.dataset.qty, 10));
      return;
    }
    const later = e.target.closest('[data-save-later]');
    if (later) {
      e.preventDefault();
      Nova.wishlist.add(later.dataset.handle);
      Nova.changeLine(later.dataset.key, 0);
      return;
    }
    const addVariant = e.target.closest('[data-add-variant]');
    if (addVariant) {
      e.preventDefault();
      addVariant.classList.add('is-loading');
      const ids = addVariant.dataset.addVariant.split(',').filter(Boolean);
      try {
        await Nova.addToCart(ids.map((id) => ({ id: parseInt(id, 10), quantity: 1 })));
      } catch (err) {}
      addVariant.classList.remove('is-loading');
      return;
    }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      const metal = Nova.getMetal();
      const id = quick.dataset[`variant${metal.charAt(0).toUpperCase()}${metal.slice(1)}`] || quick.dataset.variant;
      quick.classList.add('is-loading');
      try {
        await Nova.addToCart([{ id: parseInt(id, 10), quantity: 1 }]);
      } catch (err) {}
      quick.classList.remove('is-loading');
    }
  });

  /* Producten per metaal toevoegen (shop de look, artikelen) */
  Nova.variantForMetal = (el) => {
    const metal = Nova.getMetal();
    return el.dataset[`variant${metal.charAt(0).toUpperCase()}${metal.slice(1)}`] || el.dataset.variant;
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-group]');
    if (!btn) return;
    e.preventDefault();
    const scope = btn.closest('[data-add-scope]') || document;
    const items = $$('[data-add-item]', scope)
      .map((el) => Nova.variantForMetal(el))
      .filter(Boolean)
      .map((id) => ({ id: parseInt(id, 10), quantity: 1 }));
    if (!items.length) return;
    btn.classList.add('is-loading');
    try {
      await Nova.addToCart(items);
    } catch (err) {}
    btn.classList.remove('is-loading');
  });
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-item][data-add-single]');
    if (!btn) return;
    e.preventDefault();
    const id = Nova.variantForMetal(btn);
    if (!id) return;
    try {
      await Nova.addToCart([{ id: parseInt(id, 10), quantity: 1 }]);
    } catch (err) {}
  });

  /* ---------- Header: megamenu en zoeken ---------- */
  const header = $('[data-header]');
  const closePanels = () => {
    $$('[data-panel].is-open').forEach((p) => p.classList.remove('is-open'));
    $$('[data-mega-trigger], [data-search-toggle]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
  };

  if (header) {
    $$('[data-mega-trigger]', header).forEach((trigger) => {
      const panel = $(`[data-panel="${trigger.dataset.megaTrigger}"]`, header);
      if (!panel) return;
      trigger.addEventListener('mouseenter', () => {
        closePanels();
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
      trigger.addEventListener('focus', () => {
        closePanels();
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
    });
    $$('.nav__link:not([data-mega-trigger])', header).forEach((l) =>
      l.addEventListener('mouseenter', () => {
        const s = $('[data-panel="search"]', header);
        if (!s || !s.classList.contains('is-open')) closePanels();
      })
    );
    header.addEventListener('mouseleave', () => {
      $$('[data-panel].is-open', header).forEach((p) => {
        if (p.dataset.panel !== 'search') p.classList.remove('is-open');
      });
    });

    const searchPanel = $('[data-panel="search"]', header);
    const searchInput = searchPanel && $('input[type="search"]', searchPanel);
    const results = searchPanel && $('[data-predictive-results]', searchPanel);
    const popular = searchPanel && $('[data-search-popular]', searchPanel);

    $$('[data-search-toggle]', header).forEach((t) =>
      t.addEventListener('click', (e) => {
        if (!searchPanel) return;
        e.preventDefault();
        const open = !searchPanel.classList.contains('is-open');
        closePanels();
        if (open) {
          searchPanel.classList.add('is-open');
          t.setAttribute('aria-expanded', 'true');
          setTimeout(() => searchInput && searchInput.focus(), 60);
        }
      })
    );

    let controller;
    let timer;
    const runSearch = () => {
      const q = searchInput.value.trim();
      if (popular) popular.hidden = q.length > 0;
      if (!q) {
        results.innerHTML = '';
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      const url = `${Nova.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,tag`;
      fetch(url, { signal: controller.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(() => {});
    };
    if (searchInput) {
      searchInput.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(runSearch, 220);
      });
      $$('[data-search-term]', searchPanel).forEach((b) =>
        b.addEventListener('click', () => {
          searchInput.value = b.dataset.searchTerm;
          runSearch();
          searchInput.focus();
        })
      );
    }

    /* Hoogte van de header voor sticky elementen */
    const wrapper = header.closest('[data-header-wrapper]') || header;
    const setH = () => document.documentElement.style.setProperty('--header-h', `${wrapper.offsetHeight}px`);
    setH();
    window.addEventListener('resize', setH);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-header]')) return;
    const s = $('[data-panel="search"].is-open');
    if (s) closePanels();
  });

  /* ---------- Terug naar boven ---------- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-to-top]')) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- Start ---------- */
  const init = () => {
    Nova.wishlist.sync();
    fillDates();
    renderLists();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    Nova.wishlist.sync();
    fillDates(e.target);
    renderLists();
  });

  Nova.$ = $;
  Nova.$$ = $$;
  Nova.fillDates = fillDates;
})();
